












































































import { Vue, Component, Watch } from "vue-property-decorator";

import { LightGallery } from "vue-light-gallery";

import PageTitle from "@/components/common/PageTitle.vue";
import { FastOrderModal } from "@/components/organisms/Modal";
import { NotFoundPage as Error } from "@/components/pages/NotFoundPage";

import { Image } from "@/services/interfaces";
import { IOrderItem } from "@/services/interfaces/requests";

import { Previews } from "./blocks/Previews";
import { Images } from "./blocks/Images";
import { Properties } from "./blocks/Properties";
import { Prices } from "./blocks/Prices";
import { Controls } from "./blocks/Controls";
import { RelatedProducts } from "./blocks/RelatedProducts";

import {
  cartModule,
  catalogModule,
  commonModule,
  personalModule,
  pricesModule,
  productModule,
} from "@/plugins/store-accessors";
import { isDiscounted } from "@/store/cart/utils";

@Component({
  components: {
    PageTitle,
    Previews,
    Images,
    Properties,
    LightGallery,
    Prices,
    Error,
    FastOrderModal,
    Controls,
    RelatedProducts,
  },
})
export default class ProductPage extends Vue {
  index: null | number = null;
  sticky = false;

  get getQuantity() {
    return catalogModule.getQuantity;
  }

  get getData() {
    return productModule.getData;
  }

  get getProductIds() {
    return cartModule.getProductIds;
  }

  get getOrder() {
    return cartModule.getOrder;
  }

  get getMeta() {
    return productModule.getMeta;
  }

  get getError() {
    return productModule.getError;
  }

  get relatedProducts() {
    return productModule.getRelatedProducts;
  }

  get isAuthorized() {
    return personalModule.isAuthorized;
  }

  get isOnDiscount() {
    return this.getData?.product ? isDiscounted(this.getData?.product) : false;
  }

  get id(): number {
    return parseInt(this.$route.params.id, 10);
  }

  get images(): Image[] {
    return this.getData?.product?.images ? this.getData.product.images : [];
  }

  get galleryImages(): Image[] {
    const images = JSON.parse(JSON.stringify(this.images));
    if (images && images.length) {
      return images.map((img: Image) => {
        img.url = "/resize_images/1920x0/90/fill" + img.url;
        return img;
      });
    }
    return images;
  }

  get isInCart(): boolean {
    return this.getProductIds.includes(this.id);
  }

  get isOnSale(): boolean {
    return !!this.getData?.product?.onSale;
  }

  get isTop(): boolean {
    return !!this.getData?.product?.is_top;
  }

  get quantity(): number {
    return this.getQuantity[this.id];
  }

  get currentPriceType() {
    return pricesModule.getCurrentPrice;
  }

  changeQuantity(pl: { val: number; id: number }) {
    return catalogModule.changeQuantity(pl);
  }

  openGallery(index: number) {
    this.index = index;
  }

  onSticky(entries: IntersectionObserverEntry[]) {
    this.sticky = !entries[0].intersectionRatio;
  }

  closeHandler() {
    cartModule.ORDER_CLEAR();
    this.mountedRequests();
  }

  addToCart(quantity: number) {
    const priceType =
      this.currentPriceType !== "hide" ? this.currentPriceType : 0;
    const payload = {
      product_id: this.id,
      quantity,
      price_type: priceType,
    };
    cartModule.addProduct(payload);
  }

  orderHandler(quantity: number) {
    const price: number = (this.getData?.product?.price as number) || 0;
    const order: IOrderItem[] = [
      {
        id: this.id,
        quantity: quantity,
        price,
        total_price: price ? price * quantity : undefined,
      },
    ];
    cartModule.ORDER_SET(order);
  }

  orderSendHandler(comment: string) {
    const payload = {
      products: this.getOrder,
      comment,
    };
    return cartModule.createOrder({ data: payload });
  }

  quantityHandler(quantity: number) {
    this.changeQuantity({ id: this.id, val: quantity });
  }

  async mountedRequests() {
    await productModule.getPage({ id: this.id });
    await cartModule.getCart();
  }

  updated() {
    commonModule.SET_INTERACTIVE();
  }

  @Watch("$route.params.id", { immediate: true })
  async onIdChange() {
    await this.mountedRequests();
  }

  created() {
    document.title = this.getMeta?.title || "";
  }

  mounted() {
    const sticky = this.$refs.intersection as Element;

    const options = {
      threshold: [1],
    };
    if (sticky) {
      const observer = new IntersectionObserver(this.onSticky, options);
      observer.observe(sticky);
    }
  }

  beforeDestroy() {
    productModule.resetStore();
  }
}
